// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"20f2934c","498":"512a1fe7","703":"5949a6f7","787":"ca1cf794"}[chunkId] + ".chunk.js";
};